import adminTable from "./adminTable/sagas";
import dataForSelect from "./dataForSelect/sagas";
import userSagas from "./user/sagas";
import commonSaga from "./common/sagas";

export default [adminTable(), dataForSelect(), userSagas(), commonSaga()];
